import { sendHttpRequest } from "lib/fetcher";
export function getAlgorithmList() {
  return sendHttpRequest({
    method: "get",
    url: "/algo/algos/camera_preset",
  });
}
export function savePresetAlgorithm(
  cameraId,
  presetId,
  algos,
  tags,
  presetLocation,
  enableInspection,
) {
  return sendHttpRequest({
    method: "put",
    url: `/camera/cameras/${cameraId}/presets/${presetId}`,
    data: {
      algos,
      tags: tags.map((tag) => ({
        name: "other",
        desc: tag,
      })),
      enableInspection,
      location: presetLocation
        ? {
            polygon: {
              latitude: presetLocation.lat,
              longitude: presetLocation.lng,
            },
          }
        : null,
    },
  });
}
export function getPresetAlgorithm(cameraId, presetId) {
  return sendHttpRequest({
    method: "get",
    url: `/camera/cameras/${cameraId}/presets/${presetId}`,
  });
}
export function saveSchedule(cameraId, checkInterval, schedules) {
  return sendHttpRequest({
    method: "put",
    url: `/camera/cameras/${cameraId}/presets_schedules`,
    data: {
      schedules,
      checkInterval,
    },
  });
}
export function getSchedule(cameraId) {
  return sendHttpRequest({
    method: "get",
    url: `/camera/cameras/${cameraId}/presets_schedules`,
  });
}
export function batchGetPresetsInfo(cameraId) {
  return sendHttpRequest({
    method: "get",
    url: `/camera/cameras/${cameraId}/presets`,
  });
}
export function batchUpdateEnableInspection(
  cameraId,
  presetIds,
  enableInspection,
) {
  return sendHttpRequest({
    method: "patch",
    url: `/camera/cameras/${cameraId}/presets`,
    data: {
      enableInspection,
      indexes: presetIds,
    },
  });
}
